import alt from '../alt';
import contractorAction from '../actions/contractorAction';

class contractorStore {
    constructor() {
        this.bindActions(contractorAction);
        this.processing = false;
        this.search = "";
        this.mcst = "";
        this.searchMode = "";
        this.staffId = "";
        this.warningMsg = "";
        this.contractorId = "";
        this.updating = false;
        this.iniLoadCondo = false;
        this.condos = [];
        this.isNew = false;
        this.iniEmailReminder = false;
        this.contractors = [];
        this.reminderEmail = [];
        this.contractor = {
            contractorName: "",
            contracts: [],
            streetName: "",
            blkNo: "",
            unitNo: "",
            postal: "",
            telephone: "",
            fax: "",
            contractorEmail: "",
            contactName: "",
            status: 0,
            totalAmount: 0,
        };


    }
    onCondoSuccess(data) {
        this.condos = data;
        this.iniLoadCondo = true;
    }
    onClear() {
        this.contractor = {
            contractorName: "",
            contracts: [],
            streetName: "",
            blkNo: "",
            unitNo: "",
            postal: "",
            telephone: "",
            fax: "",
            contractorEmail: "",
            contactName: "",
            status: 0,
            totalAmount: 0,
        };
    }
    onListClear() {
        this.contractors = [];
    }
    onReset() {
        this.updating = false;
        this.searchMode = "";
    }
    onReminderEmail(data){
        this.reminderEmail = data;
        this.iniEmailReminder = true;
    }
    onProcessing(data) {
        this.processing = data;
    }
    onSearch(data) {
        this.search = data;
    }
    onMcst(data) {
        this.mcst = data;
    }
    onContractorId(data) {
        this.contractorId = data;
    }
    onUpdating(data) {
        this.updating = data;
    }
    onContractorsSuccess(data) {
        this.contractors = data;

    }
    onContractorSuccess(data) {
        this.contractor = data;
    }
    onWarningMsg(data) {
        this.warningMsg = data;
    }
    onContractor(data) {
        this.contractor = data;
    }
    onIsNew(data) {
        this.isNew = data;
    }
    onStaffId(data) {
        this.staffId = data;
    }
    onShouldListShow(data) {
        this.contractor.contracts[data].shouldListShow = !this.contractor.contracts[data].shouldListShow;
    }
    onShouldConListShow(data) {
        this.contractors[data].shouldListShow = !this.contractors[data].shouldListShow;
    }
    onSearchMode(data) {
        this.searchMode = data;
    }
    onAddCondo(data) {
        this.contractor.contracts.push({
            mcst: data.mcst,
            condoName: data.condoName,
            contract: []
        });

    }
    onAddWholeCondo(data) {
        this.contractors.push(data);
    }
    onAddService(data) {
        let len = this.contractor.contracts.length;
        let amount;
        let editCondo;
        for (let i = 0; i < len; i++) {
            if (this.contractor.contracts[i].mcst == data.mcst) {
                amount = data.contract.amount;
                this.contractor.contracts[i].contract.push(data.contract);
                editCondo = { mcst: this.contractor.contracts[i].mcst, condoName: this.contractor.contracts[i].condoName };
                break;
            }
        }
        this.updateContractAmount(amount);

    }
    onRemoveCondo(data) {
        //remove condo from contractor list
        let amount = 0;
        for (let j = 0; j < this.contractor.contracts.length; j++) {
            if (this.contractor.contracts[j].mcst == data.mcst) {
                if (this.contractor.contracts[j].contract) {
                    this.contractor.contracts[j].contract.forEach((ct) => {
                        if (ct.amount) {
                            amount = ct.amount + amount;
                        }
                    });
                }
                this.contractor.contracts.splice(j, 1);
                break;
            }
        }
        this.updateContractAmount(-amount);
    }
    onUpdateWholeCondo(data) {
        let len = this.contractors.length;
        for (let i = 0; i < len; i++) {
            if (this.contractors[i].mcst == data.mcst) {
                this.contractors[i] = data;
                break;
            }
        }
    }
    onRemoveWholeCondo(data) {
        let len = this.contractors.length;
        for (let i = 0; i < len; i++) {
            if (this.contractors[i].mcst == data.mcst) {
                this.contractors.splice(i, 1);
                break;
            }
        }
    }
    updateContractAmount(amount) {
        if (amount) {
            this.contractor.totalAmount = this.contractor.totalAmount + amount;
        }
    }
    onEditService(data) {
        let len = this.contractor.contracts.length;
        let amount;
        let editCondo;
        for (let i = 0; i < len; i++) {
            if (this.contractor.contracts[i].mcst == data.mcst) {
                amount = data.contract.amount - this.contractor.contracts[i].contract[data.index].amount;
                this.contractor.contracts[i].contract[data.index] = data.contract;
                editCondo = { mcst: this.contractor.contracts[i].mcst, condoName: this.contractor.contracts[i].condoName };
                break;
            }
        }
        this.updateContractAmount(-amount);

    }
    onRemoveService(data) {
        let len = this.contractor.contracts.length;
        let amount;
        for (let i = 0; i < len; i++) {
            if (this.contractor.contracts[i].mcst == data.mcst) {
                amount = this.contractor.contracts[i].contract[data.index].amount;
                this.contractor.contracts[i].contract.splice(data.index, 1);

                break;
            }
        }
        this.updateContractAmount(-amount);
    }
    onAddAddress(data) {
        this.contractor.addresses.push(data);
    }

    onEditAddress(data) {
        this.contractor.addresses[data.index] = data.address;
    }
    onRemoveAddress(data) {
        this.contractor.addresses.splice(data.index, 1);
    }
    onRemoveContractorSuccess(data) {
        let len = this.contractors.length;
        for (let i = 0; i < len; i++) {
            for (let j = 0; j < this.contractors[i].contractors.length; j++) {
                if (this.contractors[i].contractors[j]._id == data) {
                    this.contractors[i].contractors.splice(j, 1);
                    break;
                }
            }
        }
    }

    onUpdateContractorSuccess(data) {
        let len = this.contractors.length;
        let ctrLen = data.contracts.length;
        for (let i = 0; i < len; i++) {
            if (this.contractors[i].contractors) {
                for (let k = 0; k < this.contractors[i].contractors.length; k++) {
                    let isExist = false;
                    let contract = [];
                    if (this.contractors[i].contractors[k]._id == data._id) {
                        isExist = true;
                        for (let j = 0; j < ctrLen; j++) {
                            if (this.contractors[i].mcst == data.contracts[j].mcst) {
                                contract = contract.concat(data.contracts[j].contract);
                            }
                        }
                    }

                    if (isExist) {
                        if (contract.length == 0) {
                            this.contractors[i].contractors.splice(k, 1);
                            break;
                        } else {
                            this.contractors[i].contractors[k].contract = contract;
                        }
                    }
                }
            } 
        }
    }
    onAddContractorSuccess(data) {
        let len = this.contractors.length;
        let ctrLen = data.contracts.length;
        for (let i = 0; i < len; i++) {
            for (let j = 0; j < ctrLen; j++) {
                if (this.contractors[i].mcst = data.contracts[j].mcst) {
                    let isRepeat = false;
                    let index = -1;
                    for (let k = 0; k < this.contractors[i].contractors.length; k++) {
                        if (this.contractors[i].contractors[k]._id == data._id) {
                            isRepeat = true;
                            index = k;
                        }
                    }
                    if (!isRepeat) {
                        //if new contractor
                        this.contractors[i].contractors.push({
                            _id: data._id,
                            contractorName: data.contractorName,
                            contractorEmail: data.contractorEmail,
                            telephone: data.telephone,
                            contactName: data.contactName,
                            fax: data.fax,
                            streetName: data.streetName,
                            blkNo: data.blkNo,
                            unitNo: data.unitNo,
                            postal: data.postal,
                            status: data.status,
                            contract: data.contract[j]
                        });
                    } else {

                        //if exist contractor
                        this.contractors[i].contractors[index].contract.push(data.contract[j]);
                    }
                }
            }

        }
        this.onClear();
    }
    onStaffReplaced(data) {
        let len = this.contractors.length;
        for (let i = 0; i < len; i++) {
            if (this.contractors[i].manageBy.staffId == data.oldStaffId) {
                this.contractors[i].manageBy = {
                    staffId: data.staffId,
                    userName: data.userName,
                    role: data.role,
                    email: data.email,
                    handPhone: data.handPhone
                };
            }
            if (this.contractors[i].supervisor.staffId == data.oldStaffId) {
                this.contractors[i].supervisor = {
                    staffId: data.staffId,
                    userName: data.userName,
                    role: data.role,
                    email: data.email,
                    handPhone: data.handPhone
                };
            }
        }
    }
}
export default alt.createStore(contractorStore, 'contractorStore');


// WEBPACK FOOTER //
// ./app/stores/contractorStore.js